module.exports = __webpack_public_path__ + "static/media/activity_dots.5f62d966.svg";